/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//suggest improvements for this component
// ran this thru claudes code refactoring tool

// when i click Add All To My Menu i get double the toast messages
// give me the entire code to copy




// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy




import React, { useEffect, useState, useRef, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

import { MdOutlineRestaurantMenu } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { IoGift } from 'react-icons/io5';
import { GoGift } from "react-icons/go";

import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';
import { update_event_details_sellerPackage } from '../../store/reducers/eventDetailsReducer';
import { products_get_by_productIds } from '../../store/reducers/homeReducer';
import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear }
    from '../../store/reducers/cartReducer';

import ShopProductGridListView from '../../components/products/ShopProductGridListView';
import GetSellerConfig from '../../components/GetSellerConfig';
import OrnamentalDivider from '../../components/customerDashboard/CustomerDashboardComponents/OrnamentalDivider';
import Modal2 from '../Modal2';
import useWindowSize from '../../utils/useWindowSize';
import toast from 'react-hot-toast';
import { currencyFormat } from '../CurrencyFormat';
import config from '../../config';

const Rating = lazy(() => import('../Rating'));

// ─── Helpers ────────────────────────────────────────────────────────────────

const formatDescription = (desc) =>
    desc
        .replaceAll("<li>", "<li style='margin-left:12px;'>")
        .replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>");

const EMPTY_PACKAGE = {
    id: 'None',
    title: '',
    intro: '',
    pricePerPerson: 0,
    minNumberPeople: 0,
    description: '',
};


// ─── Component ───────────────────────────────────────────────────────────────

const SellerPackages = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { userInfo }       = useSelector(state => state.auth);
    const { sellerPackages } = useSelector(state => state.sellerPackage);
    const { eventDetails }   = useSelector(state => state.eventDetails);
    const { cart_products, successMessage, errorMessage } = useSelector(state => state.cart);
    const { products }       = useSelector(state => state.home);

    const {
        sellerPrimaryColor1, sellerPrimaryColor2,
        sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight,
        sellerComponentBackgroundColor,
        sellerBoolShowSiteChat, sellerBoolShowSitePayments, sellerBoolShowSiteRating,
    } = GetSellerConfig();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [selectedPackage, setSelectedPackage]           = useState(EMPTY_PACKAGE);
    const [sampleMenus, setSampleMenus]                   = useState([]);
    const [sampleMenusDisplay, setSampleMenusDisplay]     = useState(false);
    const [selectedSampleMenuId, setSelectedSampleMenuId] = useState('None');
    const [modalProduct, setModalProduct]                 = useState(null);
    const suppressToasts = useRef(false);

    const visibleSampleMenus = sampleMenus.filter(d => d.isVisible === 'Show');

    // ── Color tokens ─────────────────────────────────────────────────────────
    const colorDark   = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorLight  = sellerPrimaryColor1 + sellerColorSuffixLight;
    const bgPanel     = sellerComponentBackgroundColor || sellerSecondaryColor1;

    // ── Effects ──────────────────────────────────────────────────────────────

    useEffect(() => {
        dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
        dispatch(get_cart_products(userInfo.id));
    }, [dispatch]);

    useEffect(() => {
        if (!sellerPackages[0]) return;
        const pkg = sellerPackages[0];
        setSelectedPackage({
            id:              pkg._id             ?? 'None',
            title:           pkg.title           ?? '',
            intro:           pkg.intro           ?? '',
            pricePerPerson:  pkg.pricePerPerson  ?? 0,
            minNumberPeople: pkg.minNumberPeople ?? 0,
            description:     pkg.description ? formatDescription(pkg.description) : '',
        });
        setSampleMenus(pkg.sampleMenus ?? []);
        setSampleMenusDisplay(false);
    }, [sellerPackages]);

    useEffect(() => {
        if (successMessage) {
            if (!suppressToasts.current) toast.success(successMessage);
            dispatch(messageClear());
            dispatch(get_cart_products(userInfo.id));
        }
        if (errorMessage) {
            if (!suppressToasts.current) toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch]);

    // ── Handlers ─────────────────────────────────────────────────────────────

    const openModal  = (product) => setModalProduct(product);
    const closeModal = ()        => setModalProduct(null);

    const redirect_chat_page = (chatTopic) => {
        navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
    };

    const handleSellerPackageChange = (e) => {
        const pkg = sellerPackages.find(p => p._id === e.target.value);
        if (!pkg) return;
        setSelectedPackage({
            id:              pkg._id,
            title:           pkg.title           ?? '',
            intro:           pkg.intro           ?? '',
            pricePerPerson:  pkg.pricePerPerson  ?? 0,
            minNumberPeople: pkg.minNumberPeople ?? 0,
            description:     pkg.description ? formatDescription(pkg.description) : '',
        });
        setSampleMenus(pkg.sampleMenus ?? []);
        setSampleMenusDisplay(false);
        setSelectedSampleMenuId('None');
    };

    const handleSampleMenuNameChange = (e) => {
        const sampleMenuId = e.target.value;
        setSelectedSampleMenuId(sampleMenuId);
        if (sampleMenuId === 'None') { setSampleMenusDisplay(false); return; }
        setSampleMenusDisplay(true);
        const menu = sampleMenus.find(m => m._id === sampleMenuId);
        if (!menu) return;
        const parsed = JSON.parse(menu.selectedProducts);
        if (parsed.length > 0)
            dispatch(products_get_by_productIds(parsed.map(p => p._id).join(',')));
    };

    const add_sample_menu_to_cart = () => {
        if (!userInfo) { navigate('/login'); return; }
        suppressToasts.current = true;
        for (const cartGroup of cart_products)
            for (const p of cartGroup.products)
                dispatch(move_from_cart_to_wishlist(p._id));
        for (const p of products)
            dispatch(add_to_cart({ userId: userInfo.id, quantity: 1, productId: p._id, portionSize: '' }));
        suppressToasts.current = false;
        toast.success('Sample menu added to your cart!');
    };

    const setMyPackage = () =>
        dispatch(update_event_details_sellerPackage({ customerId: userInfo.id, title: selectedPackage.title }));

    const clearMyPackage = () =>
        dispatch(update_event_details_sellerPackage({ customerId: userInfo.id, title: 'None' }));

    // ── Style helpers ─────────────────────────────────────────────────────────

    const selectStyle = {
        color:           sellerPrimaryColor1,
        backgroundColor: colorLight, 
        borderColor:     colorMedium,
    };

    const primaryBtnStyle = {
        backgroundColor: sellerPrimaryColor1,
        color:           '#ffffff',
    };

    const ghostBtnStyle = {
        borderColor:     sellerPrimaryColor1,
        color:           sellerPrimaryColor1,
        backgroundColor: 'transparent',
    };

    const panelStyle = {
        border:       `1px solid ${colorDark}`,
        borderTop:    `6px solid ${colorDark}`,
    };

    const panelHeaderStyle = {
        borderBottom: `1px solid ${colorMedium}`,
        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
    };

    // ── Render ────────────────────────────────────────────────────────────────

    return (
        <div className='bg-white rounded-2xl'>
            <div
                className="rounded-2xl p-4 overflow-hidden"
                style={{
                    border:          `1px solid ${colorDark}`,
                    backgroundColor: colorLight,
                    color:           sellerPrimaryColor1,
                }}>
                {/* ══ Card header ═══════════════════════════════════════════════════ */}
                <div
                    className="flex flex-wrap items-center justify-between gap-2 px-0 py-0"
                    style={{
                        borderBottom:    `1px solid ${colorLight}`,
                        //backgroundColor: sellerPrimaryColor1 + '0d',
                    }}>
                    
                    <div className="flex items-center gap-2 mb-1 pb-0">
                        <div>
                            <GoGift size={70} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                        </div>
                        <div>
                            <div
                                className="text-2xl font-bold tracking-tight leading-none"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                Packages
                            </div>
                            <div className="text-[13px] sm:text-xs xs:text-xs mt-0.5" 
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                Choose a package that best fits your event and budget needs.
                            </div>
                            <div className="text-[13px] sm:text-xs xs:text-xs" 
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                You can always change or remove the package later.
                            </div>
                        </div>
                    </div>
                    
                    <select
                        onChange={handleSellerPackageChange}
                        className="rounded-xl border-2 px-4 py-1 text-sm font-medium cursor-pointer focus:outline-none 
                        transition-shadow duration-200"
                        style={selectStyle}>
                        {sellerPackages.map(c => (
                            <option key={c._id} value={c._id}>{c.title}</option>
                        ))}
                    </select>
                </div>

                {/* ══ Active-package banner ═════════════════════════════════════════ */}
                {eventDetails?.selectedSellerPackage !== 'None' && (
                    <>
                        <div
                            className="mx-5 flex items-center justify-between rounded-xl px-4 py-2 text-sm"
                            style={{
                                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                border:          `1px solid ${colorDark}`,
                            }}>
                            <div className="flex items-center gap-2 min-w-0">
                                <IoGift style={{ color: sellerPrimaryColor1, flexShrink: 0 }} />
                                <span style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>Selected:</span>
                                <span className="font-semibold truncate" style={{ color: sellerPrimaryColor1 }}>
                                    {eventDetails?.selectedSellerPackage}
                                </span>
                            </div>
                            <button
                                onClick={clearMyPackage}
                                className="ml-3 flex-shrink-0 rounded-full border px-3 py-0.5 text-xs font-medium
                                    transition-all duration-200 hover:opacity-70 active:scale-95"
                                style={ghostBtnStyle}>
                                Remove
                            </button>
                        </div>
                    </>
                )}

                {/* ══ Two-panel grid ════════════════════════════════════════════════
                    mobile  → 1 col (stacked)
                    desktop → 2 equal cols (side by side)  */}
                <OrnamentalDivider  />

                <div className="grid grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-4 px-5 pb-5">

                    {/* ── Panel 1 — Package details ──────────────────────────────── */}
                    <div className="flex flex-col rounded-xl overflow-hidden" style={panelStyle}>

                        {/* Panel header */}
                        <div className="flex items-center justify-between px-4 py-2.5" style={panelHeaderStyle}>
                            <span
                                className="text-xs font-semibold uppercase tracking-widest"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                Details
                            </span>
                            {selectedPackage.pricePerPerson > 0 && (
                                <button
                                    onClick={setMyPackage}
                                    className="flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold
                                        transition-all duration-200 hover:opacity-90 active:scale-95"
                                    style={primaryBtnStyle}>
                                    <IoGift className="text-sm" />
                                    Set as My Package
                                </button>
                            )}
                        </div>

                        {/* Panel body */}
                        <div className="flex-1 overflow-y-auto p-4 space-y-1" style={{ maxHeight: '320px' }}>
                            <h3 className="text-base font-semibold leading-snug" 
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                {selectedPackage.title}
                            </h3>

                            {selectedPackage.intro && (
                                <p className="text-sm italic leading-relaxed"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    {selectedPackage.intro}
                                </p>
                            )}

                            {selectedPackage.pricePerPerson > 0 && (
                                <>
                                    <div className="flex items-center gap-2">
                                        <div className="flex-1 h-px" style={{ backgroundColor: colorMedium }} />
                                        <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colorDark }} />
                                        <div className="flex-1 h-px" style={{ backgroundColor: colorMedium }} />
                                    </div>
                                    <div className="grid grid-cols-2 gap-2 text-sm">
                                        {[
                                            { label: 'Per Person',  value: currencyFormat.format(selectedPackage.pricePerPerson) },
                                            { label: 'Min. Guests', value: selectedPackage.minNumberPeople },
                                        ].map(({ label, value }) => (
                                            <div
                                                key={label}
                                                className="rounded-lg px-3 py-2"
                                                style={{
                                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                                    border:          `1px solid ${colorDark}`,
                                                    borderTop:       `3px solid ${colorDark}`,
                                                }}>
                                                <div className="text-xs uppercase tracking-widest mb-0.5"
                                                    style={{ color: sellerPrimaryColor1 }}>
                                                    {label}
                                                </div>
                                                <div className="font-semibold" style={{ color: sellerPrimaryColor1 }}>
                                                    {value}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            {selectedPackage.description && (
                                <div
                                    className="prose prose-sm max-w-none text-sm leading-relaxed"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    dangerouslySetInnerHTML={{ __html: selectedPackage.description }}
                                />
                            )}
                        </div>
                    </div>

                    {/* ── Panel 2 — Sample menus ─────────────────────────────────── */}
                    <div className="flex flex-col rounded-xl overflow-hidden" style={panelStyle}>

                        {/* Panel header */}
                        <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2.5"
                            style={panelHeaderStyle}>
                            <span
                                className="text-xs font-semibold uppercase tracking-widest"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                Sample Menus
                            </span>

                            {visibleSampleMenus.length > 0 && (
                                <select
                                    id="sampleMenuDropdown"
                                    value={selectedSampleMenuId}
                                    onChange={handleSampleMenuNameChange}
                                    className="rounded-full border px-3 py-1 text-xs font-medium cursor-pointer focus:outline-none"
                                    style={selectStyle}>
                                    <option value="None">Select Sample Menu</option>
                                    {visibleSampleMenus.map(c => (
                                        <option key={c._id} value={c._id}>{c.title}</option>
                                    ))}
                                </select>
                            )}
                        </div>

                        {/* Panel body */}
                        <div className="flex-1 flex flex-col p-4 gap-3" style={{ minHeight: '280px' }}>
                            {!sampleMenusDisplay ? (
                                <div className="flex-1 flex flex-col items-center justify-center gap-2">
                                    <MdOutlineRestaurantMenu className="text-3xl"
                                        style={{ color: sellerPrimaryColor1 }} />
                                    <p className="text-sm text-center" style={{ color: sellerPrimaryColor1 }}>
                                        Select a sample menu above to preview dishes
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <button
                                        onClick={add_sample_menu_to_cart}
                                        className="w-full flex items-center justify-center gap-1 rounded-xl py-2
                                            text-sm font-semibold transition-all duration-200
                                            hover:opacity-90 active:scale-[0.98]"
                                        style={primaryBtnStyle}>
                                        <MdOutlineRestaurantMenu className="text-base" />
                                        Add All to My Menu
                                        {products.length > 0 && (
                                            <span
                                                className="ml-1 rounded-full px-2 py-0.5 text-xs font-bold"
                                                style={{ backgroundColor: 'rgba(255,255,255,0.25)' }}>
                                                {products.length}
                                            </span>
                                        )}
                                    </button>

                                    {products?.length > 0 && (
                                        <div
                                            className="flex-1 overflow-y-auto"
                                            style={{ color: sellerPrimaryColor1, maxHeight: '260px' 
                                            }}>
                                            <ShopProductGridListView
                                                products={products}
                                                styles="grid"
                                                showAllProductsButton={false}
                                                columnCount={1}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
            </div>
        </div>
    );
};

export default SellerPackages;






//before redeisgn
// import React, { useEffect, useState, useRef, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, Link } from 'react-router-dom';
// import Accordion from '../Accordion';

// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { FaEye } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { IoGift } from 'react-icons/io5';
// import { GoGift } from "react-icons/go";

// import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';
// import { update_event_details_sellerPackage } from '../../store/reducers/eventDetailsReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear }
//     from '../../store/reducers/cartReducer';

// import ShopProductGridListView from '../../components/products/ShopProductGridListView'; 
// import GetSellerConfig from '../../components/GetSellerConfig';

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import config from '../../config';

// const Rating = lazy(() => import('../Rating'));

// // ─── Helpers ────────────────────────────────────────────────────────────────

// const formatDescription = (desc) =>
//     desc
//         .replaceAll("<li>", "<li style='margin-left:12px;'>")
//         .replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>");

// const EMPTY_PACKAGE = {
//     id: 'None',
//     title: '',
//     intro: '',
//     pricePerPerson: 0,
//     minNumberPeople: 0,
//     description: '',
// };

// // ─── Component ───────────────────────────────────────────────────────────────

// const SellerPackages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     //const { seller }                    = useSelector(state => state.seller);
//     const { userInfo }                  = useSelector(state => state.auth);
//     const { sellerPackages }            = useSelector(state => state.sellerPackage);
//     const { eventDetails }              = useSelector(state => state.eventDetails);
//     const { cart_products, successMessage, errorMessage } = useSelector(state => state.cart);
//     const { products }                  = useSelector(state => state.home);

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
//         sellerBoolShowSitePayments, sellerBoolShowSiteRating
//     } = GetSellerConfig();

//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { screenWidth } = useWindowSize();

//     // ── Local state ──────────────────────────────────────────────────────────
//     const [selectedPackage, setSelectedPackage]           = useState(EMPTY_PACKAGE);
//     const [sampleMenus, setSampleMenus]                   = useState([]);
//     const [sampleMenusDisplay, setSampleMenusDisplay]     = useState(false);
//     const [selectedSampleMenuId, setSelectedSampleMenuId] = useState('None');
//     const [modalProduct, setModalProduct]                 = useState(null);

//     // Ref to suppress intermediate toasts during bulk add
//     const suppressToasts = useRef(false);

//     // ── Derived ──────────────────────────────────────────────────────────────
//     const visibleSampleMenus = sampleMenus.filter(d => d.isVisible === 'Show');

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1,
//     };

//     // ── Effects ──────────────────────────────────────────────────────────────

//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
//         dispatch(get_cart_products(userInfo.id));
//     }, [dispatch]);

//     // Initialise selected package from first item once packages load
//     useEffect(() => {
//         if (!sellerPackages[0]) return;
//         const pkg = sellerPackages[0];
//         setSelectedPackage({
//             id:               pkg._id       ?? 'None',
//             title:            pkg.title     ?? '',
//             intro:            pkg.intro     ?? '',
//             pricePerPerson:   pkg.pricePerPerson   ?? 0,
//             minNumberPeople:  pkg.minNumberPeople  ?? 0,
//             description:      pkg.description ? formatDescription(pkg.description) : '',
//         });
//         setSampleMenus(pkg.sampleMenus ?? []);
//         setSampleMenusDisplay(false);
//     }, [sellerPackages]);

//     // Toast notifications — skipped during bulk add to prevent duplicates
//     useEffect(() => {
//         if (successMessage) {
//             if (!suppressToasts.current) {
//                 toast.success(successMessage);
//             }
//             dispatch(messageClear());
//             dispatch(get_cart_products(userInfo.id));
//         }
//         if (errorMessage) {
//             if (!suppressToasts.current) {
//                 toast.error(errorMessage);
//             }
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     // ── Handlers ─────────────────────────────────────────────────────────────

//     const openModal  = (product) => setModalProduct(product);
//     const closeModal = ()        => setModalProduct(null);

//     const redirect_chat_page = (chatTopic) => {
//         navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
//     };

//     const handleSellerPackageChange = (e) => {
//         const sellerPackageId = e.target.value;
//         const pkg = sellerPackages.find(p => p._id === sellerPackageId);
//         if (!pkg) return;

//         setSelectedPackage({
//             id:              pkg._id,
//             title:           pkg.title           ?? '',
//             intro:           pkg.intro           ?? '',
//             pricePerPerson:  pkg.pricePerPerson  ?? 0,
//             minNumberPeople: pkg.minNumberPeople ?? 0,
//             description:     pkg.description ? formatDescription(pkg.description) : '',
//         });
//         setSampleMenus(pkg.sampleMenus ?? []);
//         setSampleMenusDisplay(false);
//         setSelectedSampleMenuId('None');
//     };

//     const handleSampleMenuNameChange = (e) => {
//         const sampleMenuId = e.target.value;
//         setSelectedSampleMenuId(sampleMenuId);

//         if (sampleMenuId === 'None') {
//             setSampleMenusDisplay(false);
//             return;
//         }

//         setSampleMenusDisplay(true);
//         const menu = sampleMenus.find(m => m._id === sampleMenuId);
//         if (!menu) return;

//         const parsed = JSON.parse(menu.selectedProducts);
//         if (parsed.length > 0) {
//             const productIds = parsed.map(p => p._id).join(',');
//             dispatch(products_get_by_productIds(productIds));
//         }
//     };

//     const add_sample_menu_to_cart = () => {
//         if (!userInfo) { navigate('/login'); return; }

//         // Suppress per-dispatch toasts for the entire bulk operation
//         suppressToasts.current = true;

//         for (const cartGroup of cart_products) {
//             for (const p of cartGroup.products) {
//                 dispatch(move_from_cart_to_wishlist(p._id));
//             }
//         }
//         for (const p of products) {
//             dispatch(add_to_cart({
//                 userId:      userInfo.id,
//                 quantity:    1,
//                 productId:   p._id,
//                 portionSize: '',
//             }));
//         }

//         // Re-enable toasts and show a single confirmation
//         suppressToasts.current = false;
//         toast.success('Sample menu added to your cart!');
//     };

//     const setMyPackage = () => {
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title:      selectedPackage.title,
//         }));
//     };

//     const clearMyPackage = () => {
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title:      'None',
//         }));
//     };

//     // ── Render ───────────────────────────────────────────────────────────────

//     const brandStyle = {
//         color:           sellerPrimaryColor1,
//         backgroundColor: sellerSecondaryColor1,
//         borderColor:     sellerPrimaryColor1,
//     };

//     const primaryBtnStyle = {
//         backgroundColor: sellerPrimaryColor1,
//         color:           'white',
//     };

//     return (
//         <div className='p-4 rounded-lg mb-2 border'
//             style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>

//             {/* ── Header ── */}
//             <div className='text-2xl flex font-bold gap-1 mb-1'>
//                 <GoGift className='mt-1 mr-1' /> Packages
//             </div>
//             <div className='ml-2 mb-2 text-sm italic'>
//                 Choose a package that best fits your event and budget needs.
//                 You can always change or remove the package later.
//             </div>

//             {/* ── Selected package banner ── */}
//             {eventDetails?.selectedSellerPackage !== 'None' && (
//                 <div className='w-full flex justify-start text-md gap-1 mb-1 ml-2'>
//                     <span className='font-normal'>Selected Package: </span>
//                     <span className='font-semibold'>{eventDetails?.selectedSellerPackage}</span>
//                     <button onClick={clearMyPackage}
//                         className='text-white w-[172px] flex py-1 px-2 rounded-lg text-md'
//                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                         <IoGift className='ml-2 mt-0.5' /> Remove Package
//                     </button>
//                 </div>
//             )}

//             {/* ── Package selector ── */}
//             <select
//                 onChange={handleSellerPackageChange}
//                 className='w-[300px] m-1 border rounded-lg px-2 py-1 font-semibold text-md cursor-pointer'
//                 style={brandStyle}>
//                 {sellerPackages.map(c => (
//                     <option key={c._id} value={c._id} className='text-sm block'>{c.title}</option>
//                 ))}
//             </select>

//             {/* ── Two-panel layout ── */}
//             <div className='flex flex-row lg:flex-col gap-2'>

//                 {/* Panel 1 – Package details */}
//                 <div className='m-1 border-2 overflow-auto h-[344px] w-[320px] p-1'
//                     style={brandStyle}>
//                     <div className='font-bold text-lg mb-1 flex justify-between'>
//                         <span className='text-lg font-semibold'>{selectedPackage.title}</span>
//                         {selectedPackage.pricePerPerson > 0 && (
//                             <button onClick={setMyPackage}
//                                 className='w-[166px] text-sm flex font-semibold text-white py-1 px-2 ml-1 rounded-lg'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <IoGift className='ml-1 mt-0.5' />
//                                 <span className='mr-1'> Set As My Package</span>
//                             </button>
//                         )}
//                     </div>

//                     <div className='ml-2'>
//                         <div className='italic break-words'>{selectedPackage.intro}</div>

//                         {selectedPackage.pricePerPerson > 0 && (
//                             <>
//                                 <div className='mt-0.5'>
//                                     <span>Price Per Person: </span>
//                                     <span className='font-semibold'>
//                                         {currencyFormat.format(selectedPackage.pricePerPerson)}
//                                     </span>
//                                 </div>
//                                 <div className='mt-0.5'>
//                                     <span>Minimum Number People: </span>
//                                     <span className='font-semibold'>{selectedPackage.minNumberPeople}</span>
//                                 </div>
//                             </>
//                         )}

//                         <div dangerouslySetInnerHTML={{ __html: selectedPackage.description }} />
//                     </div>
//                 </div>

//                 {/* Panel 2 – Sample menus */}
//                 <div className='m-1 w-[320px] h-[344px] border-2 text-center items-center justify-center justify-items-center'
//                     style={brandStyle}>

//                     {!sampleMenusDisplay && (
//                         <div className='font-semibold text-[15px] p-1'>
//                             Select A Package For The Sample Menus
//                         </div>
//                     )}

//                     <div className='border-none border-black mb-2'>
//                         {visibleSampleMenus.length > 0 && (
//                             <select
//                                 id="sampleMenuDropdown"
//                                 value={selectedSampleMenuId}
//                                 onChange={handleSampleMenuNameChange}
//                                 className='w-[230px] border rounded-lg px-2 py-1 m-1 font-semibold text-md cursor-pointer'
//                                 style={brandStyle}>
//                                 <option value='None' className='text-sm block'>Select Sample Menu</option>
//                                 {visibleSampleMenus.map(c => (
//                                     <option key={c._id} value={c._id} className='text-sm block'>{c.title}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {sampleMenusDisplay && (
//                             <button
//                                 onClick={add_sample_menu_to_cart}
//                                 className='items-center justify-center text-center w-[230px] py-0.5 px-2 m-1 flex text-white rounded-md text-[15px]'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <MdOutlineRestaurantMenu className='mt-0.5 mr-0.5 text-[18px]' /> 
//                                 {`Add All To My Menu (${products.length})`}
//                             </button>
//                         )}
//                     </div>
//                     <div>
//                     {
//                         sampleMenusDisplay && products?.length > 0  && (
//                             <div className='border-none mb-2 overflow-y-auto h-[250px] w-[300px]'
//                                 style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                 <ShopProductGridListView products={products}
//                                     styles="grid" showAllProductsButton={false} columnCount={1} />
//                             </div>
//                         )
//                     }
//                     </div>

//                     {/* Product list */}
//                     {sampleMenusDisplay && products?.length > 0 && (
//                         <div className='hidden border-2 mb-2 overflow-y-auto h-[250px] w-[300px]'
//                             style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                             {[...products]
//                                 .sort((a, b) => a.name.localeCompare(b.name))
//                                 .map(p => (
//                                     <div key={p._id}
//                                         className='w-[96%] border-none group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                                         style={brandStyle}>

//                                         <div className='relative overflow-hidden'>
//                                             <div className='relative text-center'>
//                                                 <img className='w-full h-[200px] object-cover' src={p.images[0]} alt={p.name} />
//                                                 {p.byThePan !== 'NoPan' && (
//                                                     <div className='m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center'
//                                                         style={brandStyle}>
//                                                         {p.byThePan}
//                                                     </div>
//                                                 )}
//                                             </div>

//                                             <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                                 <li>
//                                                     <Link onClick={() => openModal(p)}
//                                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                         style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                         <div className='icon-container'>
//                                                             <span className='icon flex justify-center items-center'>
//                                                                 &nbsp;<FaEye />&nbsp;
//                                                             </span>
//                                                             <div className='tooltip' style={tooltipHoverStyle}>Quick<br />View</div>
//                                                         </div>
//                                                     </Link>
//                                                 </li>

//                                                 {sellerBoolShowSiteChat && (
//                                                     <li>
//                                                         <span onClick={() => redirect_chat_page(p.name)}
//                                                             className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                             style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                             <div className='icon-container'>
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                 </span>
//                                                                 <div className='tooltip' style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                             </div>
//                                                         </span>
//                                                     </li>
//                                                 )}
//                                             </ul>
//                                         </div>

//                                         <div className='py-3 px-2'>
//                                             <span className='font-bold truncate block'>{p.name}</span>
//                                             <div className='flex justify-start items-center gap-3'>
//                                                 {sellerBoolShowSitePayments && (
//                                                     <span className='text-md font-semibold'>
//                                                         {currencyFormat.format(p.price)}
//                                                     </span>
//                                                 )}
//                                                 {sellerBoolShowSiteRating && (
//                                                     <Rating ratings={p.rating} />
//                                                 )}
//                                             </div>
//                                         </div>

//                                         <div className='border px-1 py-1 mb-1 w-full text-[14px] font-semibold'
//                                             style={brandStyle}>
//                                             <span className='line-clamp-2'>{p.description}</span>
//                                         </div>
//                                     </div>
//                                 ))}
//                         </div>
//                     )}
//                 </div>
//             </div>
//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </div>
//     );
// };

// export default SellerPackages;




// double the toast messages
// import React, { useEffect, useState, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, Link } from 'react-router-dom';
// import Accordion from '../Accordion';

// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { FaEye } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { IoGift } from 'react-icons/io5';
// import { GoGift } from "react-icons/go";

// import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';
// import { update_event_details_sellerPackage } from '../../store/reducers/eventDetailsReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear }
//     from '../../store/reducers/cartReducer';

// import ShopProductGridListView from '../../components/products/ShopProductGridListView';    
// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';
// import config from '../../config';

// const Rating = lazy(() => import('../Rating'));

// // ─── Helpers ────────────────────────────────────────────────────────────────

// const formatDescription = (desc) =>
//     desc
//         .replaceAll("<li>", "<li style='margin-left:12px;'>")
//         .replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>");

// const EMPTY_PACKAGE = {
//     id: 'None',
//     title: '',
//     intro: '',
//     pricePerPerson: 0,
//     minNumberPeople: 0,
//     description: '',
// };

// // ─── Component ───────────────────────────────────────────────────────────────

// const SellerPackages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     const { seller }                    = useSelector(state => state.seller);
//     const { userInfo }                  = useSelector(state => state.auth);
//     const { sellerPackages }            = useSelector(state => state.sellerPackage);
//     const { eventDetails }              = useSelector(state => state.eventDetails);
//     const { cart_products, successMessage, errorMessage } = useSelector(state => state.cart);
//     const { products }                  = useSelector(state => state.home);

//     const sellerId              = seller._id;
//     const sellerPrimaryColor1   = seller.frontEndPrimaryColor1;
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1;

//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show';
//     const sellerBoolShowSiteRating   = seller.isVisibleSiteRating   === 'Show';
//     const sellerBoolShowSiteChat     = seller.isVisibleSiteChat     === 'Show';

//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { screenWidth } = useWindowSize();

//     // ── Local state ──────────────────────────────────────────────────────────
//     const [selectedPackage, setSelectedPackage]           = useState(EMPTY_PACKAGE);
//     const [sampleMenus, setSampleMenus]                   = useState([]);
//     const [sampleMenusDisplay, setSampleMenusDisplay]     = useState(false);
//     const [selectedSampleMenuId, setSelectedSampleMenuId] = useState('None');
//     const [modalProduct, setModalProduct]                 = useState(null);

//     // ── Derived ──────────────────────────────────────────────────────────────
//     const visibleSampleMenus = sampleMenus.filter(d => d.isVisible === 'Show');

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1,
//     };

//     // ── Effects ──────────────────────────────────────────────────────────────

//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
//         dispatch(get_cart_products(userInfo.id));
//     }, [dispatch]);

//     // Initialise selected package from first item once packages load
//     useEffect(() => {
//         if (!sellerPackages[0]) return;
//         const pkg = sellerPackages[0];
//         setSelectedPackage({
//             id:               pkg._id       ?? 'None',
//             title:            pkg.title     ?? '',
//             intro:            pkg.intro     ?? '',
//             pricePerPerson:   pkg.pricePerPerson   ?? 0,
//             minNumberPeople:  pkg.minNumberPeople  ?? 0,
//             description:      pkg.description ? formatDescription(pkg.description) : '',
//         });
//         setSampleMenus(pkg.sampleMenus ?? []);
//         setSampleMenusDisplay(false);
//     }, [sellerPackages]);

//     // Toast notifications
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//             dispatch(get_cart_products(userInfo.id));
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     // ── Handlers ─────────────────────────────────────────────────────────────

//     const openModal  = (product) => setModalProduct(product);
//     const closeModal = ()        => setModalProduct(null);

//     const redirect_chat_page = (chatTopic) => {
//         navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
//     };

//     const handleSellerPackageChange = (e) => {
//         const sellerPackageId = e.target.value;
//         const pkg = sellerPackages.find(p => p._id === sellerPackageId);
//         if (!pkg) return;

//         setSelectedPackage({
//             id:              pkg._id,
//             title:           pkg.title           ?? '',
//             intro:           pkg.intro           ?? '',
//             pricePerPerson:  pkg.pricePerPerson  ?? 0,
//             minNumberPeople: pkg.minNumberPeople ?? 0,
//             description:     pkg.description ? formatDescription(pkg.description) : '',
//         });
//         setSampleMenus(pkg.sampleMenus ?? []);
//         setSampleMenusDisplay(false);
//         setSelectedSampleMenuId('None');
//     };

//     const handleSampleMenuNameChange = (e) => {
//         const sampleMenuId = e.target.value;
//         setSelectedSampleMenuId(sampleMenuId);

//         if (sampleMenuId === 'None') {
//             setSampleMenusDisplay(false);
//             return;
//         }

//         setSampleMenusDisplay(true);
//         const menu = sampleMenus.find(m => m._id === sampleMenuId);
//         if (!menu) return;

//         const parsed = JSON.parse(menu.selectedProducts);
//         if (parsed.length > 0) {
//             const productIds = parsed.map(p => p._id).join(',');
//             dispatch(products_get_by_productIds(productIds));
//         }
//     };

//     const add_sample_menu_to_cart = () => {
//         if (!userInfo) { navigate('/login'); return; }

//         for (const cartGroup of cart_products) {
//             for (const p of cartGroup.products) {
//                 dispatch(move_from_cart_to_wishlist(p._id));
//             }
//         }
//         for (const p of products) {
//             dispatch(add_to_cart({
//                 userId:      userInfo.id,
//                 quantity:    1,
//                 productId:   p._id,
//                 portionSize: '',
//             }));
//         }
//     };

//     const setMyPackage = () => {
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title:      selectedPackage.title,
//         }));
//     };

//     const clearMyPackage = () => {
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title:      'None',
//         }));
//     };

//     // ── Render ───────────────────────────────────────────────────────────────

//     const brandStyle = {
//         color:           sellerPrimaryColor1,
//         backgroundColor: sellerSecondaryColor1,
//         borderColor:     sellerPrimaryColor1,
//     };

//     const primaryBtnStyle = {
//         backgroundColor: sellerPrimaryColor1,
//         color:           'white',
//     };

//     return (
//         <div className='p-4 rounded-lg mb-2 border'
//             style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>

//             {/* ── Header ── */}
//             <div className='text-2xl flex font-bold gap-1 mb-1'>
//                 <GoGift className='mt-1 mr-1' /> Packages
//             </div>
//             <div className='ml-2 mb-2 text-sm italic'>
//                 Choose a package that best fits your event and budget needs.
//                 You can always change or remove the package later.
//             </div>

//             {/* ── Selected package banner ── */}
//             {eventDetails?.selectedSellerPackage !== 'None' && (
//                 <div className='w-full flex justify-start text-md gap-1 mb-1 ml-2'>
//                     <span className='font-normal'>Selected Package: </span>
//                     <span className='font-semibold'>{eventDetails?.selectedSellerPackage}</span>
//                     <button onClick={clearMyPackage}
//                         className='text-white w-[172px] flex py-1 px-2 rounded-lg text-md'
//                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                         <IoGift className='ml-2 mt-0.5' /> Remove Package
//                     </button>
//                 </div>
//             )}

//             {/* ── Package selector ── */}
//             <select
//                 onChange={handleSellerPackageChange}
//                 className='w-[300px] m-1 border rounded-lg px-2 py-1 font-semibold text-md cursor-pointer'
//                 style={brandStyle}>
//                 {sellerPackages.map(c => (
//                     <option key={c._id} value={c._id} className='text-sm block'>{c.title}</option>
//                 ))}
//             </select>

//             {/* ── Two-panel layout ── */}
//             <div className='flex flex-row lg:flex-col gap-2'>

//                 {/* Panel 1 – Package details */}
//                 <div className='m-1 border-2 overflow-auto h-[344px] w-[320px] p-1'
//                     style={brandStyle}>
//                     <div className='font-bold text-lg mb-1 flex justify-between'>
//                         <span className='text-lg font-semibold'>{selectedPackage.title}</span>
//                         {selectedPackage.pricePerPerson > 0 && (
//                             <button onClick={setMyPackage}
//                                 className='w-[166px] text-sm flex font-semibold text-white py-1 px-2 ml-1 rounded-lg'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <IoGift className='ml-1 mt-0.5' />
//                                 <span className='mr-1'> Set As My Package</span>
//                             </button>
//                         )}
//                     </div>

//                     <div className='ml-2'>
//                         <div className='italic break-words'>{selectedPackage.intro}</div>

//                         {selectedPackage.pricePerPerson > 0 && (
//                             <>
//                                 <div className='mt-0.5'>
//                                     <span>Price Per Person: </span>
//                                     <span className='font-semibold'>
//                                         {currencyFormat.format(selectedPackage.pricePerPerson)}
//                                     </span>
//                                 </div>
//                                 <div className='mt-0.5'>
//                                     <span>Minimum Number People: </span>
//                                     <span className='font-semibold'>{selectedPackage.minNumberPeople}</span>
//                                 </div>
//                             </>
//                         )}

//                         <div dangerouslySetInnerHTML={{ __html: selectedPackage.description }} />
//                     </div>
//                 </div>

//                 {/* Panel 2 – Sample menus */}
//                 <div className='m-1 w-[320px] h-[344px] border-2 text-center items-center justify-center justify-items-center'
//                     style={brandStyle}>

//                     {!sampleMenusDisplay && (
//                         <div className='font-semibold text-[15px] p-1'>
//                             Select A Package For The Sample Menus
//                         </div>
//                     )}

//                     <div className='border-none border-black mb-2'>
//                         {visibleSampleMenus.length > 0 && (
//                             <select
//                                 id="sampleMenuDropdown"
//                                 value={selectedSampleMenuId}
//                                 onChange={handleSampleMenuNameChange}
//                                 className='w-[210px] border rounded-lg px-2 py-1 m-1 font-semibold text-md cursor-pointer'
//                                 style={brandStyle}>
//                                 <option value='None' className='text-sm block'>Select Sample Menu</option>
//                                 {visibleSampleMenus.map(c => (
//                                     <option key={c._id} value={c._id} className='text-sm block'>{c.title}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {sampleMenusDisplay && (
//                             <button
//                                 onClick={add_sample_menu_to_cart}
//                                 className='items-center justify-center text-center w-[210px] py-0.5 px-3 m-1 flex text-white rounded-md text-[16px]'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <MdOutlineRestaurantMenu className='mt-0.5 mr-1 text-[18px]' /> Add All To My Menu
//                             </button>
//                         )}
//                     </div>
//                     <div>
//                     {
//                         sampleMenusDisplay && products?.length > 0  && (
//                             <div className='border-none mb-2 overflow-y-auto h-[250px] w-[300px]'
//                                 style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                 <ShopProductGridListView products={products}
//                                     styles="grid" showAllProductsButton={false} columnCount={1} />
//                             </div>
//                         )
//                     }
//                     </div>

//                     {/* Product list */}
//                     {sampleMenusDisplay && products?.length > 0 && (
//                         <div className='hidden border-2 mb-2 overflow-y-auto h-[250px] w-[300px]'
//                             style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                             {[...products]
//                                 .sort((a, b) => a.name.localeCompare(b.name))
//                                 .map(p => (
//                                     <div key={p._id}
//                                         className='w-[96%] border-none group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                                         style={brandStyle}>

//                                         <div className='relative overflow-hidden'>
//                                             <div className='relative text-center'>
//                                                 <img className='w-full h-[200px] object-cover' src={p.images[0]} alt={p.name} />
//                                                 {p.byThePan !== 'NoPan' && (
//                                                     <div className='m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center'
//                                                         style={brandStyle}>
//                                                         {p.byThePan}
//                                                     </div>
//                                                 )}
//                                             </div>

//                                             <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                                 <li>
//                                                     <Link onClick={() => openModal(p)}
//                                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                         style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                         <div className='icon-container'>
//                                                             <span className='icon flex justify-center items-center'>
//                                                                 &nbsp;<FaEye />&nbsp;
//                                                             </span>
//                                                             <div className='tooltip' style={tooltipHoverStyle}>Quick<br />View</div>
//                                                         </div>
//                                                     </Link>
//                                                 </li>

//                                                 {sellerBoolShowSiteChat && (
//                                                     <li>
//                                                         <span onClick={() => redirect_chat_page(p.name)}
//                                                             className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                             style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                             <div className='icon-container'>
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                 </span>
//                                                                 <div className='tooltip' style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                             </div>
//                                                         </span>
//                                                     </li>
//                                                 )}
//                                             </ul>
//                                         </div>

//                                         <div className='py-3 px-2'>
//                                             <span className='font-bold truncate block'>{p.name}</span>
//                                             <div className='flex justify-start items-center gap-3'>
//                                                 {sellerBoolShowSitePayments && (
//                                                     <span className='text-md font-semibold'>
//                                                         {currencyFormat.format(p.price)}
//                                                     </span>
//                                                 )}
//                                                 {sellerBoolShowSiteRating && (
//                                                     <Rating ratings={p.rating} />
//                                                 )}
//                                             </div>
//                                         </div>

//                                         <div className='border px-1 py-1 mb-1 w-full text-[14px] font-semibold'
//                                             style={brandStyle}>
//                                             <span className='line-clamp-2'>{p.description}</span>
//                                         </div>
//                                     </div>
//                                 ))}
//                         </div>
//                     )}
//                 </div>
//             </div>
//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </div>
//     );
// };

// export default SellerPackages;



//my original code
// import React, { useEffect, useState, lazy }  from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {  useNavigate, Link } from 'react-router-dom';
// import Accordion from '../Accordion';

// import { HiOutlineMagnifyingGlassPlus } from "react-icons/hi2";
// import { HiOutlineMagnifyingGlassMinus } from "react-icons/hi2";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { FaEye, FaRegTrashAlt} from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { IoGift } from 'react-icons/io5';
// import { GoGift } from "react-icons/go";

// import { get_sellerPackages_webSiteOrigin, get_one_sellerPackage } from '../../store/reducers/sellerPackageReducer';
// import { update_event_details_sellerPackage, get_event_details } from '../../store/reducers/eventDetailsReducer';
// import {sampleMenu_ParentSellerPackageId_get} from '../../store/reducers/sampleMenuReducer';
// import { products_get_by_productIds } from '../../store/reducers/homeReducer';
// import { add_to_cart, get_cart_products, move_from_cart_to_wishlist, messageClear, successMessage, errorMessage } 
//     from '../../store/reducers/cartReducer';

// import Modal2 from '../Modal2';
// import useWindowSize from '../../utils/useWindowSize';
// import toast from 'react-hot-toast';
// import { currencyFormat } from '../CurrencyFormat';

// import Moment from 'moment/moment';
// import config from '../../config';

// const Rating = lazy(()=> import('../Rating')) 

// //https://www.youtube.com/@codecommerce
// //https://www.youtube.com/watch?v=oOXExNA8A48
// //Build an Accordion Menu with React & Tailwind CSS

// const SellerPackages = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL

//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)
//     const { sellerPackages, totalSellerPackage} = useSelector(state => state.sellerPackage)
//     const { eventDetails } = useSelector(state => state.eventDetails);
//     const { cart_products, cart_product_count, buy_product_item, wishlist_count,
//             shipping_fee, outofstock_products, errorMessage, successMessage } = useSelector(state => state.cart) //outOfStockProduct price,
        
//     let { allSiteProducts, products, totalProduct } = useSelector(state => state.home)
        
//     const [sampleMenus, setSampleMenus] = useState([])
//     const [sampleMenusDisplay, setSampleMenusDisplay] = useState(false)

//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
    
//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller.isVisibleSiteChat === 'Show' ? true : false
    
//     const dispatch = useDispatch()
//     const navigate = useNavigate()

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };
//     const { screenWidth, screenHeight } = useWindowSize();
    
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };
    
//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const add_sample_menu_to_cart_local = () => {
//         if (userInfo) {
//             //loop
//             if (cart_products.length > 0) {
//                 cart_products[0].products.map((p, i) => {
//                     //console.log('p._id ', p._id)
//                     dispatch(move_from_cart_to_wishlist(p._id))
//                 })
//             }

//             products.map((p, i) => {
//                 //console.log('p._id ', p._id, p.name)
//                 dispatch(add_to_cart({
//                     userId: userInfo.id,
//                     quantity: 1,
//                     productId : p._id, // product._id,
//                     portionSize: '' //portionSize
//                 }))  
//             })
//         } else {
//             navigate('/login')
//         }
//     }


//     let sampleMenusCount = 0
//     const incrementSampleMenusCount = () => {
//         sampleMenusCount = sampleMenusCount + 1; // Direct modification
//         //console.log(sampleMenusCount); // This will show the updated value in the console
//     };
    
//     const handleSampleMenuNameChange = (event) => {
//         //console.log('event.target.value ', event.target.value)
//         const sampleMenuId = event.target.value
//         if (sampleMenuId === 'None') {
//             setSampleMenusDisplay(false)
//             return
//         }
//         //setSampleMenusDisplay(false)
                    
//         //console.log('sampleMenuId ', sampleMenuId)
//         setSampleMenusDisplay(true)
//         sampleMenus.forEach((sampleMenu) => {
//             if (sampleMenu._id === sampleMenuId) {
//             let productIds = ''
//                 //products = null setProductsDisplay
//                 if (JSON.parse(sampleMenu.selectedProducts).length > 0) {
//                     //setCustomMenuItems(JSON.parse(eventDetails?.customMenuProducts) )//|| eventDetails?.customMenuProducts
//                     //console.log('eventDetails?.customMenuProducts', eventDetails?.customMenuProducts)
//                     JSON.parse(sampleMenu.selectedProducts).map((p, i) => (
//                         productIds += `${p._id},`
//                     ))
//                     productIds = productIds.substring(0, productIds.length - 1);
//                     //console.log('productIds', productIds)
//                     dispatch(products_get_by_productIds(productIds))
//                     //console.log('products ', products)
//                 } 
//             }
//         })
//         //dispatch(get_one_sellerPackage(sampleMenuId))
//     }
//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL))
//     },[])

//     const update_event_details_sellerPackage_local = () => {
//         //console.log(pro)
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title: selectedSellerPackageTitle //'None'
//         }))

//         // dispatch(get_event_details(userInfo.id))
//         // console.log(eventDetails?.selectedSellerPackage)
//     }
//     const clear_update_event_details_sellerPackage_local = () => {
//         //console.log(pro)
//         dispatch(update_event_details_sellerPackage({
//             customerId: userInfo.id,
//             title: 'None'
//         }))

//         // dispatch(get_event_details(userInfo.id))
//         // console.log(eventDetails?.selectedSellerPackage)
//     }

//     const [selectedSellerPackageId, setSelectedSellerPackageId] = useState('None')
//     const [selectedSellerPackageTitle, setSelectedSellerPackageTitle] = useState('')
//     const [selectedSellerPackageIntro, setSelectedSellerPackageIntro] = useState('')
//     const [selectedSellerPackagePricePerPerson, setSelectedSellerPackagePricePerPerson] = useState(0)
//     const [selectedSellerPackageMinNumberPeople, setSelectedSellerPackageMinNumberPeople] = useState(0)
//     const [selectedSellerPackageDescription, setSelectedSellerPackageDescription] = useState('')
    
//     useEffect(() => {
//         if (sellerPackages[0]?.title) {
//             setSelectedSellerPackageTitle(sellerPackages[0]?.title)
//         }
//     },[sellerPackages])
    
//     useEffect(() => {
//         if (sellerPackages[0]?.intro) {
//             setSelectedSellerPackageIntro(sellerPackages[0]?.intro)
//         }
//     },[sellerPackages])
    
//     useEffect(() => {
//         if (sellerPackages[0]?.pricePerPerson) {
//             setSelectedSellerPackagePricePerPerson(sellerPackages[0]?.pricePerPerson)
//         }
//     },[sellerPackages])

//     useEffect(() => {
//         if (sellerPackages[0]?.minNumberPeople) {
//             setSelectedSellerPackageMinNumberPeople(sellerPackages[0]?.minNumberPeople)
//         }
//     },[sellerPackages])

//     useEffect(() => {
//         if (sellerPackages[0]?.description) {
//             let description = sellerPackages[0]?.description
//             description = description.replaceAll("<li>", "<li style='margin-left:12px;'>")//<span>&#46;</span>
//             description = description.replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>")//<span>&#46;</span>
//             setSelectedSellerPackageDescription(description)
//         }
//     },[sellerPackages])

//     useEffect(() => {
//         if (sellerPackages[0]?.sampleMenus) {
//             setSampleMenus(sellerPackages[0]?.sampleMenus)
//             setSampleMenusDisplay(false)
//             //setSelectedSellerPackageId(sellerPackages[0]?._id)
//         }
//     },[sellerPackages])

//     useEffect(() => {
//         dispatch(get_cart_products(userInfo.id))
//     },[])
        
//     //let productIdsArray = []
//     const handleSellerPackageChange = (event) => {
//         //console.log('event.target.value ', event.target.value)
//         const sellerPackageId = event.target.value
//         try {
//             //console.log('sellerPackageId ', sellerPackageId)
//             sellerPackages.forEach((sellerPackage) => {
//                 if (sellerPackage._id === sellerPackageId) {
//                     //console.log('sellerPackage ', sellerPackage)
//                     setSelectedSellerPackageId(sellerPackageId) //sellerPackage._id)
//                     setSelectedSellerPackageTitle(sellerPackage.title)
//                     setSelectedSellerPackageIntro(sellerPackage.intro)
//                     setSelectedSellerPackagePricePerPerson(sellerPackage.pricePerPerson)
//                     setSelectedSellerPackageMinNumberPeople(sellerPackage.minNumberPeople)

//                     let description = sellerPackage?.description
//                     description = description.replaceAll("<li>", "<li style='margin-left:12px;'>")//<span>&#46;</span>
//                     description = description.replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>")//<span>&#46;</span>
//                     setSelectedSellerPackageDescription(description)

//                     //dispatch(sampleMenu_ParentSellerPackageId_get(sellerPackageId))
//                     setSampleMenus(sellerPackage?.sampleMenus)  // || []
//                     setSampleMenusDisplay(false)
                    
//                     const myDropdown = document.getElementById('sampleMenuDropdown'); // Replace 'yourDropdownId' with the actual ID of your select element
//                     myDropdown.selectedIndex = 0;
//                     //sampleMenuDropdown.option = 0
//                     // works
                    
//                     //dispatch(sampleMenu_ParentSellerPackageId_get(sellerPackage._id))
                    
//                     //console.log('sampleMenus ', sampleMenus[0]?.title)
//                     //console.log('sellerPackage ', sellerPackage?.sampleMenus)
//                 }
//             })
            
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//             dispatch(get_cart_products(userInfo.id))
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div className='p-4 rounded-lg mb-2 border' 
//             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//             <div className='justify-start'>
//                 <div className='text-2xl flex font-bold gap-1 mb-1'>
//                     <GoGift className='mt-1 mr-1' /> Packages
//                 </div>
//                 <div className='ml-2 mb-2 text-sm italic'>
//                     Choose a package that best fits your event and budget needs.
//                     You can always change or remove the package later.
//                 </div>
//                 {
//                     //w-[360px] grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1
//                     // h-[30px]
//                 }
//                 <div className={` ${eventDetails?.selectedSellerPackage === 'None' ? 'hidden' : 'block'}  
//                     w-full flex justify-start text-md gap-1 mb-1 ml-2`}>
//                     <span className='font-normal'>Selected Package: </span>
//                     <span className='font-semibold'>{eventDetails?.selectedSellerPackage}</span>
                    
//                     <button onClick={clear_update_event_details_sellerPackage_local}
//                         className='text-white w-[172px] flex py-1 px-2 rounded-lg text-md'
                        
//                         style={{backgroundColor:sellerPrimaryColor1}}>
//                         <IoGift className='ml-2 mt-0.5' /> Remove Package
//                     </button>
//                 </div>
//                 <select onChange={(e) => handleSellerPackageChange(e)}
//                     className='w-[300px] m-1 border rounded-lg px-2 py-1 font-semibold text-md cursor-pointer' 
//                     style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                     {
//                         sellerPackages.map((c, i) => 
//                             <option key={i} value={c._id} className={`text-sm block`}>{c.title}</option>
//                         )
//                     }
//                 </select>
                
//                 {
//                 //react show 2 table cells side by side on a large screen and one on top of another on a small screen style with tailwind
//                 //https://www.google.com/search?q=react+show+2+table+cells+side+by+side+on+a+large+screen+and+one+on+top+of+another+on+a+small+screen+style+with+tailwind&rlz=1C1RXQR_enUS1019US1019&sourceid=chrome&ie=UTF-8&udm=50&aep=48&cud=0&qsubts=1762202585465&mtid=IhQJac6TCq2h5NoP7_-PwAE&mstk=AUtExfDq5rx7Nc2vSwVZ6VKInvoWqX5raLr5qD3SZSW-7x-v-u2mw1gUu5XvinhPJt_pchR9vS1P5KzzmrlfA1wr0oQAVOJX1bLHEVwrxkJAB_PxcfJoDgL3xYja1YZ2JJVt2GU0aqm6SSCGhSBfzHySzGSLeBy36yIWmK7IHmdduKs_00vphzMXSsYcyd2tUYzds6nHryE-DJaTY9imcSndfg01ZwVp4OZTVkMthf5GzZCDVUlWsHGDwYJBk8JjzJPLYhrBv3TCAZmnwJrm0mxAtkjKPkY4_N3GUJQ&csuir=1
//                 }

                
                
//                 {
//                 //react show 2 table cells side by side on a small screen and one on top of another on a large screen using <table> elements and style with tailwind
//                 }

//                 <div className="">
//                     <h2 className="hidden text-xl font-semibold mb-4">Reverse Responsive Table Layout</h2>
//                     <p className="hidden mb-4">
//                         Resize screen: Side-by-side on small, stacked on large.
//                     </p>
//                     {/*  min-w-full */}
//                     <table className="border-collapse border-none border-gray-700">
//                         <thead>
//                             <tr className="hidden" >
//                                 <th className="border border-gray-300 p-2">Header 1</th>
//                                 <th className="border border-gray-300 p-2">Header 2</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {/* Key here: Default is table-row, but we override at 'lg' breakpoint */}
//                             <tr className=" table-row lg:flex lg:flex-col">
//                                 {/* On small screens, these TDs are normal table cells (side-by-side) */}
//                                 {/* On large screens (lg:), they become blocks and stack */}
//                                 <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                     {/* overflow: 'auto',  maxWidth: '420px', maxHeight: '50vh', */}
//                                     <div className={`m-1 border-2 overflow-auto h-[344px] w-[320px]`} 
//                                         style={{ padding: '4px',  
//                                         borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1 }}>
//                                         <div className='font-bold text-lg mb-1 flex justify-between'>
//                                             <span className='text-lg font-semibold'>{selectedSellerPackageTitle}</span>
//                                             <span>
//                                                 <button onClick={update_event_details_sellerPackage_local} 
//                                                     className={` ${selectedSellerPackagePricePerPerson > 0 ? '' : 'hidden'}  
//                                                     w-[166px] text-sm flex font-semibold text-white py-1 px-2 ml-1 rounded-lg`}
//                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                     <IoGift className='ml-1 mt-0.5' /><span className='mr-1'> Set As My Package</span>
//                                                 </button>
//                                             </span>
//                                         </div>
//                                         <div className='ml-2'>
//                                             <div className={` italic break-words `} >
//                                                 {selectedSellerPackageIntro}
//                                             </div>
//                                             <div className={`  ${selectedSellerPackagePricePerPerson > 0 ? '' : 'hidden'} mt-0.5`}>
//                                                 <span>Price Per Person: </span>
//                                                 <span className='font-semibold'>
//                                                     { currencyFormat.format(selectedSellerPackagePricePerPerson) }
//                                                 </span> 
//                                             </div>
//                                             <div className={`  ${selectedSellerPackagePricePerPerson > 0 ? '' : 'hidden'} mt-0.5`}>
//                                                 <span>Minimum Number People: </span>
//                                                 <span className='font-semibold'>{ selectedSellerPackageMinNumberPeople}</span>
//                                             </div>
//                                             <div dangerouslySetInnerHTML={{__html: selectedSellerPackageDescription}} />
//                                         </div>
//                                     </div>
//                                 </td>
                                
//                                 <td className="align-top border-none table-cell lg:block">
//                                     <div className={`m-1 w-[320px] h-[344px] border-2 text-center items-center justify-center justify-items-center`}
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <div className={` ${sampleMenusDisplay ? 'hidden' : ''} 
//                                             font-semibold text-[15px] p-1 `}>
//                                             Select A Package For The Sample Menus
//                                         </div>
//                                         {
//                                             sampleMenus.filter((d) => d.isVisible === 'Show').map((d, i) => 
//                                                 incrementSampleMenusCount()
//                                             )
//                                         }
//                                         <div className='border-none border-black mb-2' >
//                                             <select id="sampleMenuDropdown" onChange={(e) => handleSampleMenuNameChange(e)}
//                                                 className={` ${sampleMenusCount === 0 ? 'hidden' : 'block'} 
//                                                 w-[210px] border rounded-lg px-2 py-1 m-1 font-semibold text-md cursor-pointer`} 
//                                                 style={{color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                 <option value='None' className={`text-sm block`}>Select Sample Menu</option>
//                                                 {
//                                                     sampleMenus.filter((d) => d.isVisible === 'Show').map((c, i) => 
//                                                         <option key={i} value={c._id} className={`text-sm block`}>{c.title}</option>
//                                                     )
//                                                 }
//                                             </select>
//                                             <button onClick={add_sample_menu_to_cart_local}
//                                                 className={`${sampleMenusDisplay ? '' : 'hidden'} 
//                                                 items-center justify-content-center justify-center text-center 
//                                                 w-[210px] py-0.5 px-3 m-1 flex text-white rounded-md text-[16px]`} 
//                                                 style={{backgroundColor:sellerPrimaryColor1, color:sellerSecondaryColor1, borderColor:sellerSecondaryColor1}}>
//                                                 <MdOutlineRestaurantMenu className='mt-0.5 mr-1 text-[18px]' /> Add All To My Menu
//                                             </button>
//                                         </div>
                        
//                                         <div className={` ${sampleMenusDisplay ? '' : 'hidden'} 
//                                             border-2 mb-2 overflow-y-scroll overflow-auto h-[250px] w-[300px] 
//                                             items-center justify-center justify-items-center`}
//                                             style={{ color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>   
//                                             {
//                                             sampleMenusDisplay && products && products.length > 0 &&
//                                                 products.slice(0, products.length).sort((a, b) => a.name.localeCompare(b.name)).map((p, i) => 
//                                                 <div key={i} className='w-[96%] border-none group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                     <div className='relative overflow-hidden'>
//                                                         <div className="relative text-center">
//                                                             <img className={`sm:w-full w-full h-[200px]`} src={p.images[0]}  alt="" />  
//                                                             <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''}  
//                                                                 m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center`}
//                                                                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                 {p.byThePan}
//                                                             </div>
//                                                         </div>
//                                                         <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center 
//                                                             gap-2 absolute w-full group-hover:bottom-3'>
//                                                             <Link onClick={() => openModal(p)}
//                                                                 className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                                 style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                 <div className="icon-container">
//                                                                     <span className='icon flex justify-center items-center'>
//                                                                         &nbsp;<FaEye />&nbsp;
//                                                                     </span>
//                                                                     <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                                 </div>
//                                                             </Link>
//                                                             <span onClick={() => redirect_chat_page(p.name)} 
//                                                                 className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                                                 w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all`}
//                                                                 style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                 <div className="icon-container">
//                                                                     <span className='icon flex justify-center items-center'>
//                                                                         &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                     </span>
//                                                                     <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                                 </div>
//                                                             </span>
//                                                         </ul>
//                                                     </div>
//                                                     <div className='py-3 px-2'>
//                                                         <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                             <span className='font-bold'>{p.name}</span>
//                                                         </div>
//                                                         <div className='sm:hidden'>
//                                                             <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                                             <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                                         </div>
//                                                         <div className='flex justify-start items-center gap-3'>
//                                                             <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                                                 {currencyFormat.format(p.price)}
//                                                             </span>
//                                                             <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                                                 <Rating ratings={p.rating} />
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 <div className={`${p.portionSizes === '' ? '' : ''} 
//                                                     border px-1 py-1 mb-1 w-full text-[14px] font-semibold`}
//                                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                                     <span className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                                         {p.description?.substring(0, parseInt(screenWidth / 10))} ...
//                                                     </span>
//                                                     <span className='sm:hidden'>
//                                                         {p.description?.substring(0, parseInt(screenWidth / 50))} ...
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                             )
//                                         }
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         </tbody>
//                     </table>
//                 </div>
//                 <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//             </div>
//             <div className='hidden'>
//              {
//                 sellerPackages.map((item, index) => 
//                     <div className='w-full'  key={index}>
//                         <Accordion title={item.title} intro={item.intro} pricePerPerson={item.pricePerPerson} 
//                             minNumberPeople={item.minNumberPeople} description={item.description} 
//                             showSetSellerPackageButton={true} />
//                     </div> 
//                 )
//             }
//             </div>
//         </div>
//     );
// };

// export default SellerPackages;
